// reference from: https://qiita.com/nightyknite/items/b2590a69f2e0135756dc
import { includes } from 'lodash'

export const ua = window.navigator.userAgent.toLowerCase()

export const deviceType = () => {
  if (
    includes(ua, 'iphone') ||
    includes(ua, 'ipad') ||
    includes(ua, 'android') ||
    includes(ua, 'mobile') ||
    includes(ua, 'blackberry')
  ) {
    return 'sp'
  }
  return 'pc'
}

export const IS_IOS = includes(ua, 'iphone') || includes(ua, 'ipad')
export const IS_ANDROID = includes(ua, 'android') && includes(ua, 'mobile')
// IE11以下の `msie` と11以降の `trident` で評価しています
export const IS_IE = includes(ua, 'msie') || includes(ua, 'trident')
export const IS_PC = deviceType() === 'pc'
